<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px" [ngClass]="['date-label']"> 
    <ng-container *ngFor="let dt of dateRange; let j = last">
        <span
            (click)="dateSelection(dt)"
            [ngStyle]="{
                'color': dt.type == selectedDateRange ? '#1271a8' : ''
            }"
            pointer>
            {{dt.label}} 
        </span>
        <div>/</div>
    </ng-container>
    <div fxLayout="row" fxLayoutGap="10px" [ngClass]="[date.startDate ? 'border-bottom' : '']">
        <span *ngIf="date.startDate" pointer fontWeight="400" fontSize="14px" fxLayout="column" fxLayoutAlign="center center" fxFlex="170px">{{(date.startDate) + ' - ' + (date.endDate)}}</span>
        <mat-icon (click)="openDialog()" pointer [style.color]="selectedDateRange == 'range' ? '#1271a8' : '#707070'" pointer>date_range</mat-icon>
    </div>
</div>